/**
 * File saver utility using the traditional download link method.
 * Simple, reliable, and works across all modern browsers.
 */

/**
 * Save a file using the traditional download link method
 */
export async function saveFile(blob: Blob, filename: string): Promise<void> {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.style.display = "none";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Clean up the URL object
  URL.revokeObjectURL(url);
}

/**
 * Save text content as a file
 */
export async function saveTextFile(
  text: string,
  filename: string
): Promise<void> {
  const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
  await saveFile(blob, filename);
}
